import serviceHandler from "@/helpers/handlers/service";
import { DialogHelper } from "@/helpers/dialog-helper";
import AlertDialog from "@/components/ui/AlertDialog";
import companyService from "@/services/company";
import { Guses } from "../../models/gus/guses.model";
import cuid from "cuid";
import { mapState } from "vuex";
import facilitiesService from "@/services/facilities";

export const companyProfileMixin = {
  data() {
    return {
      form: {
        name: {
          name: "name",
          id: cuid(),
          label: "message.common.legalCompanyName",
          required: true,
          value: "",
          positionLeft: true
        },
        gov_tax_number: {
          name: "gov_tax_number",
          id: cuid(),
          label: "message.common.taxNumber",
          required: true,
          value: "",
          positionLeft: true
        },
        legal_name: {
          name: "legal_name",
          id: cuid(),
          label: "message.common.legalCompanyName",
          required: true,
          value: "",
          positionLeft: true
        },
        email: {
          name: "email",
          id: cuid(),
          label: "message.common.emailAddress",
          required: true,
          value: "",
          positionLeft: true
        },
        city: {
          name: "city",
          id: cuid(),
          label: "message.common.city",
          required: false,
          value: "",
          positionLeft: false
        },
        postal_code: {
          name: "postalCode",
          id: cuid(),
          label: "message.common.postcode",
          required: false,
          value: "",
          positionLeft: false
        },
        street: {
          name: "street",
          id: cuid(),
          label: "message.wizard.streetAndHomeNumber",
          required: false,
          value: "",
          positionLeft: false
        },
        country: {
          name: "country",
          id: cuid(),
          label: "message.common.country",
          required: false,
          value: "",
          positionLeft: false,
          disabled: true
        },
        country_code: {
          name: "country_code",
          id: cuid(),
          label: "message.common.country",
          required: true,
          value: "PL",
          positionLeft: false
        },
        categories: {
          name: "trade",
          id: cuid(),
          label: "message.common.trade",
          required: false,
          value: []
        },
        facebook_url: {
          id: cuid(),
          value: ""
        },
        instagram_url: {
          id: cuid(),
          value: ""
        }
      },
      countries: []
    };
  },
  computed: {
    ...mapState({
      items: state => state.company.categories,
      loading: state => state.company.loading,
      companyId: state => state.company.company.id,
      company: state => state.company.company,
      selectedLocale: state => state.settings.selectedLocale
    }),

    isFormChanged() {
      return Object.keys(this.fields).some(key => this.fields[key].dirty);
    }
  },
  methods: {
    idFromObj(val) {
      return val.map(item => item.id || item);
    },

    setForm() {
      Object.entries(this.company).map(([k, v]) =>
        this.form[k] ? (this.form[k].value = v) : false
      );
    },

    handleEditClick() {
      this.editable = true;
    },

    handleCancelClick() {
      this.editable = false;
      this.setForm();
    },

    handleSaveClick() {
      this.validate();
    },

    async validate() {
      await this.$validator.validate().then(isTrue => {
        isTrue ? this.submit() : null;
      });
    },

    submit() {
      if (this.isFormChanged) {
        this.updateCompanyData();

        this.$validator.reset();
      } else {
        this.editable = false;
      }
    },

    async updateCompanyData() {
      const formValues = {};
      this.form.categories.value = this.idFromObj(this.form.categories.value);

      Object.entries(this.form).map(([k, v]) => (formValues[k] = v.value));

      const result = await serviceHandler(
        companyService.updateCompany(formValues, this.companyId)
      );

      if (result) {
        this.editable = false;
        await this.$store.dispatch("company/fetchCompanies");
        await this.$store.dispatch("company/setCompany", {
          company: result
        });
      } else {
        this.$store.commit("company/SET_LOADING", true);
        this.setForm();
        this.$store.commit("company/SET_LOADING", false);
      }
    },

    async onTaxNumberSearch(e) {
      e.preventDefault();
      this.taxNumberDataLoading = true;
      try {
        await this.getGovTaxNumberData();
        this.dataInputType = "from_nip";
      } catch (e) {
        this.validTaxNumber = false;
        this.errors.add({
          field: this.$t(this.form.gov_tax_number.label),
          msg: ""
        });
      } finally {
        this.taxNumberDataLoading = false;
      }
    },

    async getGovTaxNumberData() {
      try {
        const data = await serviceHandler(
          companyService.getGus(this.form.gov_tax_number.value)
        );

        if (data && data.length > 0) {
          const guses = new Guses(data);
          const { name, street, propertyNumber, postalCode, city } = guses[0];

          this.form.legal_name.value = `${name}`;
          this.form.street.value =
            street && propertyNumber
              ? `${street || ""} ${propertyNumber || ""}`
              : "";
          this.form.postal_code.value = `${postalCode || ""}`;
          this.form.city.value = `${city || ""}`;
        }
      } catch (e) {
        this.showCompanyNotFoundDialog();
        throw e;
      }
    },

    showCompanyNotFoundDialog() {
      DialogHelper.showDialog(
        AlertDialog,
        {
          text: `${this.$t("message.wizard.validation.companyNotFound")}`,
          buttonText: `${this.$t("message.common.close")}`
        },
        []
      );
    },

    async fetchCountries() {
      const countryChoices = await serviceHandler(
        facilitiesService.getCountries()
      );
      this.countries = countryChoices;
    }
  }
};
